export const loadMetricsModule = () => import("web-vitals");
